
import React from 'react';

interface ReviewStatsProps {
  totalReviews: number;
  ratingFilter: string | null;
}

export function ReviewStats({ totalReviews, ratingFilter }: ReviewStatsProps) {
  return (
    <div className="text-sm text-muted-foreground">
      Total reviews: <span className="font-medium">{totalReviews}</span>
      {ratingFilter && ratingFilter !== 'all' && (
        <> with {ratingFilter} star{parseInt(ratingFilter) !== 1 ? 's' : ''}</>
      )}
    </div>
  );
}
